import { render, staticRenderFns } from "./ProjectJudicialVerification.vue?vue&type=template&id=221be28e&scoped=true&"
import script from "./ProjectJudicialVerification.vue?vue&type=script&lang=js&"
export * from "./ProjectJudicialVerification.vue?vue&type=script&lang=js&"
import style0 from "./ProjectJudicialVerification.vue?vue&type=style&index=0&id=221be28e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221be28e",
  null
  
)

export default component.exports